import React from "react";

const appVersion = import.meta.env.VITE_APP_VERSION;

const MenuFooter = () => (
  <div className="footer-tag">
    <p>
      IRIS ™ {`v${appVersion}`} <br /> © 2019 GraVoc Associates, Inc.
    </p>
  </div>
);

export default MenuFooter;
